var NotificationBase = require('./NotificationBase');

var NoDomainNotification = require('./Notifications/NoDomainNotification');
var ChatNotification = require('./Notifications/ChatNotification');
var BrowserUpgradeNotification = require('./Notifications/BrowserUpgradeNotification');
var NotPublishedNotification = require('./Notifications/NotPublishedNotification');
var MaintenanceModeNotification = require('./Notifications/MaintenanceModeNotification');
var LoginNotification = require('./Notifications/LoginNotification');
var FilemanagerNotification = require('./Notifications/FilemanagerNotification');
var TopicChangeNotification = require('./Notifications/TopicChangeNotification');
var CongratsNotification = require('./Notifications/CongratsNotification');
var GuidanceNotification = require('./Notifications/GuidanceNotification');
var BlogMobileAppNotification = require('./Notifications/BlogMobileAppNotification');
var EMPNotification = require('./Notifications/EMPNotification');
var ExternalWebsiteImportNotification = require('./Notifications/ExternalWebsiteImportNotification');
var ExternalWebsiteImportBlueNotification = require('./Notifications/ExternalWebsiteImportBlueNotification');
var XingVouchersNotification = require('./Notifications/XingVouchersNotification');
var WebComponentUpsellFinishedNotification = require('./Notifications/WebComponentUpsellFinishedNotification');
var SectionsWelcomeNotification = require('./Notifications/SectionsWelcomeNotification');

/**
 *
 */
(function() {

    var NotificationFactory = Klazz.extend({
        classMap: {
            1: ChatNotification,
            //2: UndoRedoNotification,
            3: BrowserUpgradeNotification,
            4: NoDomainNotification,
            5: MaintenanceModeNotification,
            //6: NTFCenterNotification,
            7: LoginNotification,
            8: FilemanagerNotification,
            9: TopicChangeNotification,
            10: CongratsNotification,
            11: NotPublishedNotification,
            12: GuidanceNotification,
            13: BlogMobileAppNotification,
            14: EMPNotification,
            15: ExternalWebsiteImportNotification,
            16: XingVouchersNotification,
            17: ExternalWebsiteImportBlueNotification,
            18: WebComponentUpsellFinishedNotification,
            19: SectionsWelcomeNotification
        },
        create: function(item) {
            var options,
                type,
                classCtor,
                notificationInstance = null;


            if (typeof item == 'object') {
                if (!item.type) {
                    throw new Error("Must specify the notification type");
                }
                options = item;
                type = options.type;
            } else {
                if (isNaN(item)) {
                    throw new Error("Must specify the notification type");
                }
                options = null;
                type = item;
            }

            classCtor = this.classMap[type];
            if (!classCtor) {
                throw new Error('Notification Class for type ' + type + ' is Undefined');
            }
            notificationInstance = new classCtor(options);
            if (!(notificationInstance instanceof NotificationBase)) {
                throw new Error('Notification Class dows not inherit the base class');
            }

            return notificationInstance;
            /*switch(item.type) {
                case 1: //fall-through
                case 2:
                    return new ns.ChatNotification(item);
                default:
                    return new ns.BasicNotification(item);
                    return new ns.FlashNotification(item);
            }*/
        },
        getType: function(type) {
            return this.classMap[type] ? this.classMap[type] : 'undefined';
        }
    });

    NotificationFactory.notificationTypes = {
        TYPE_CHAT: 1,
        TYPE_UNDO_REDO: 2,
        TYPE_BROWSER_UPGRADE: 3,
        TYPE_NO_DOMAIN: 4,
        TYPE_MAINTENANCE: 5,
        TYPE_NTFCENTER: 6,
        TYPE_LOGIN: 7,
        TYPE_FILEMANAGER: 8,
        TYPE_TOPIC_CHANGE: 9,
        TYPE_CONGRATULATIONS: 10,
        TYPE_NOT_PUBLISHED: 11,
        TYPE_GUIDANCE: 12,
        TYPE_BLOG_MOBILE_APP: 13,
        TYPE_EMP: 14,
        TYPE_EXTERNAL_WEBSITE_IMPORT: 15,
        TYPE_XING_VOUCHERS: 16,
        TYPE_EXTERNAL_WEBSITE_IMPORT_BLUE: 17,
        TYPE_WEBCOMPONENT_UPSELL_FINISHED: 18,
        TYPE_SECTIONS_WELCOME: 19
    };

    module.exports = NotificationFactory;

}());



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/toolbar/notification/NotificationFactory.js
 ** module id = 646
 ** module chunks = 0
 **/